var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSpinnerWhite = props => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 144 144",
  style: {
    enableBackground: "new 0 0 144 144"
  },
  xmlSpace: "preserve"
}, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M63.7,23.8v17.6c-15.5,0-25.3,13.7-25.3,31.6s12.6,32.5,28.1,32.5v17.6C40.9,123.1,20,100.6,20,73 S38,23.8,63.7,23.8z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
  className: "st0",
  points: "22.4,21.9 63.7,21.9 63.7,59.1  "
})))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M81.3,121.2v-17.6c15.5,0,25.3-13.7,25.3-31.6S93.9,39.5,78.4,39.5V21.9c25.7,0,46.6,22.5,46.6,50.1 S107,121.2,81.3,121.2z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
  className: "st0",
  points: "122.6,123.1 81.3,123.1 81.3,85.9  "
})))));
export { SvgSpinnerWhite as ReactComponent };
export default __webpack_public_path__ + "assets/96319ade.svg";